import { PunchoutProducts } from '../../../../components/Punchout/PunchoutCategoryList.js';
import type { Category } from '../../../../common/types/category.js';

interface PunchoutStoreProductsProps {
  category: Category;
}

export const PunchoutStoreProducts = ({ category }: PunchoutStoreProductsProps) => {
  return <PunchoutProducts category={category} />;
};
